import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "id", "dimmed", "vAlign", "spacingLeft", "spacingRight"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Icon from 'components/Icon';
import VisuallyHidden from 'components/VisuallyHidden';
import Tooltip from 'components/Tooltip';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function HintTooltip(_ref) {
  var content = _ref.content,
    id = _ref.id,
    _ref$dimmed = _ref.dimmed,
    dimmed = _ref$dimmed === void 0 ? true : _ref$dimmed,
    _ref$vAlign = _ref.vAlign,
    vAlign = _ref$vAlign === void 0 ? true : _ref$vAlign,
    spacingLeft = _ref.spacingLeft,
    spacingRight = _ref.spacingRight,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
      content: content
    }, otherProps), {}, {
      children: function children(_ref2) {
        var ref = _ref2.ref,
          open = _ref2.open,
          close = _ref2.close;
        return /*#__PURE__*/_jsx(Icon, {
          name: "info",
          ref: ref,
          dimmed: dimmed,
          vAlign: vAlign,
          ml: spacingLeft,
          mr: spacingRight,
          onMouseEnter: open,
          onMouseLeave: close,
          onFocus: open,
          onBlur: close,
          tabIndex: 0
        });
      }
    })), content &&
    /*#__PURE__*/
    // The icon triggering the tooltip is invisible
    // to screenreaders, so we add the hint text
    // in a way that makes it discoverable for them
    _jsx(VisuallyHidden, {
      id: id,
      children: content
    })]
  });
}
export default HintTooltip;